export const T = {
  en_GB: {
    financialSummary: "Financial Summary",
    netWorth: "Net Worth",
    debtToIncomeRatio: "Debt-to-Income Ratio",
    monthlyDebtServiceRatio: "Monthly Debt Service Ratio",
    savingsRate: "Savings Rate",
  },
  nb_NO: {
    financialSummary: "Finansielt sammendrag",
    netWorth: "Netto formue",
    debtToIncomeRatio: "Gjeld-til-inntekt-forhold",
    monthlyDebtServiceRatio: "Månedlig gjeldsbetjeningsgrad",
    savingsRate: "Sparerate",
  },
} as const;
